import { render, staticRenderFns } from "./AttendanceGrid.vue?vue&type=template&id=24d6a2da&scoped=true"
import script from "./AttendanceGrid.ts?vue&type=script&lang=ts&external"
export * from "./AttendanceGrid.ts?vue&type=script&lang=ts&external"
import style0 from "./AttendanceGrid.vue?vue&type=style&index=0&id=24d6a2da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d6a2da",
  null
  
)

export default component.exports